module.exports = __webpack_public_path__ + "img/Logo Classify_Blue_Circle.34411b2e.png";